import React, { useEffect, useState } from "react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { SimpleItem } from 'devextreme-react/form';
import { NumberBox } from "devextreme-react";
import { LVForm } from "../../../Basicos/LVForm";
import { Padding } from "@mui/icons-material";

function LVBonificacionesRecargos({ onClickAplicar, onClickBorrar, onChangeBonificacion, onChangeRecargo }) {

  const onClickAplicarLocal = () => {
    onClickAplicar();
  };

  const onClickBorrarLocal = () => {
    onClickBorrar();
  };

  const handleChangeBonificacion = (e) => {
    onChangeBonificacion(e.value);
  };

  const handleChangeRecargo = (e) => {
    onChangeRecargo(e.value);
  };

  return (
    <div className="LV-GroupBox-div LV-FlexContainer">
      <NumberBox label="% BONIFIC." width={'40%'} onValueChanged={handleChangeBonificacion} />
      <NumberBox label="% RECARGO" width={'25%'} visible={false} onValueChanged={handleChangeRecargo} />
      <LVButtonAccion Texto="✔️" Ancho={60}
        onClick={onClickAplicarLocal}/>
      <LVButtonAccion Texto="❌" Ancho={60}
        onClick={onClickBorrarLocal} />
    </div>
  );
}

export default LVBonificacionesRecargos